import { SensitiveDataFormField } from "types/Models/sensitiveData";

const toComparable = (value: unknown): string => {
  if (value === null || value === undefined) return "";

  return String(value).toLowerCase();
};

export const isSensitiveDataFieldVisible = (
  field: SensitiveDataFormField,
  valueByFieldKey: Record<string, unknown>
): boolean => {
  const { depends_on, is_derived } = field;

  if (!depends_on) return true;

  if (is_derived) return true;

  const dependencyValue = toComparable(valueByFieldKey[depends_on.field_key]);
  return depends_on.values.some(
    (allowed) => toComparable(allowed) === dependencyValue
  );
};
